import { render, staticRenderFns } from "./footerPage.vue?vue&type=template&id=838cbe4e&scoped=true"
import script from "./footerPage.vue?vue&type=script&lang=js"
export * from "./footerPage.vue?vue&type=script&lang=js"
import style0 from "./footerPage.vue?vue&type=style&index=0&id=838cbe4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838cbe4e",
  null
  
)

export default component.exports